import { Star, Tag, MapPin, Hotel, ArrowRight } from "lucide-react";
import api from "../api/api";
import { useEffect, useState } from "react";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";
import {
    Wifi,
    Car,
    Utensils,
    Dumbbell,
    Waves,
} from "lucide-react";

import {
    BadgePercent,
    TicketPercent,
    Sparkles,
    Crown,
    Zap,
    ShieldCheck,
} from "lucide-react";


export default function FeaturedHotels({ limit = null }) {
    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadedImages, setLoadedImages] = useState({});

    const amenityIcons = {
        "Free WiFi": <Wifi size={12} />,
        "Free Parking": <Car size={12} />,
        Restaurant: <Utensils size={12} />,
        "Fitness Centre": <Dumbbell size={12} />,
        "Swimming Pool": <Waves size={12} />,
    };



    useEffect(() => {
        api.get("/hotels")
            .then((response) => {
                // console.log("RAW API RESPONSE:", response.data);

                const data = limit
                    ? response.data.slice(0, limit)
                    : response.data;

                // console.log("FINAL HOTELS DATA:", data);

                setHotels(data);
            })
            .catch((error) => {
                console.error("Error fetching hotels:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [limit]);


    if (loading) {
        return (
            <FeaturedLoader
                title="Loading popular destination"
                subtitle="Preparing the best deals for you..."
            />
        );
    }

    return (
        <section
            className="
    py-24
    bg-gradient-to-b
   from-[#F8F4EC]
via-[#FBF8F2]
to-[#F8F4EC]
   dark:from-[#08111F]
dark:via-[#0F172A]
dark:to-[#08111F]
  "
        >
            <div className="container mx-auto px-6">
                {/* Heading */}
                <div className="mb-16 text-center">
                    <span
                        className="
          inline-flex
          items-center
          gap-2
          text-xs
          font-semibold
          uppercase
          tracking-[0.25em]
          text-[#0F766E]
          mb-4
        "
                    >
                        FEATURED HOTELS
                    </span>

                    <h2
                        className="
          text-4xl
          lg:text-5xl
          font-bold
          text-slate-900
          dark:text-white
          mb-4
        "
                    >
                        Handpicked Stays For You
                    </h2>

                    <p
                        className="
          max-w-2xl
          mx-auto
          text-sm
          lg:text-base
          text-gray-500
          dark:text-gray-400
        "
                    >
                        Explore our carefully selected luxury and boutique hotels across Dubai,
                        Abu Dhabi and the UAE with exclusive member-only prices.
                    </p>
                </div>

                {/* Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-12">
                    {hotels.slice(0, 6).map((hotel) => (
                        <div
                            key={hotel.id}
                            className="group rounded-[32px] transition duration-500"
                        >

                            {/* Skeleton Card */}
                            {!loadedImages[hotel.id] && (
                                <div className="
                    rounded-[32px]
                    overflow-hidden
                    bg-white
                    shadow-lg
                    animate-pulse
                ">

                                    {/* Image Skeleton */}
                                    <div className="
                        h-[320px]
                        bg-gradient-to-r
                        from-gray-200
                        via-gray-100
                        to-gray-200
                    "></div>


                                    {/* Content Skeleton */}
                                    <div className="p-5 space-y-4">

                                        <div className="h-5 bg-gray-200 rounded w-3/4"></div>

                                        <div className="h-3 bg-gray-200 rounded w-full"></div>

                                        <div className="h-3 bg-gray-200 rounded w-5/6"></div>


                                        <div className="flex gap-2">
                                            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                                            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                                        </div>


                                        <div className="border-t pt-4 flex justify-between">
                                            <div className="h-8 w-28 bg-gray-200 rounded"></div>
                                            <div className="h-5 w-20 bg-gray-200 rounded"></div>
                                        </div>

                                    </div>

                                </div>
                            )}



                            {/* Actual Card */}
                            <div
                                className={`
                    transition-all
                    duration-700
                    ${loadedImages[hotel.id]
                                        ? "opacity-100 translate-y-0"
                                        : "opacity-0 hidden"
                                    }
                `}
                            >

                                <a href={`/hotels/${hotel.slug ?? hotel.id}`}>

                                    <div className="relative overflow-hidden rounded-t-[140px]">


                                        <img
                                            src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                            alt={hotel.name}
                                            onLoad={() =>
                                                setLoadedImages((prev) => ({
                                                    ...prev,
                                                    [hotel.id]: true,
                                                }))
                                            }
                                            className="
                                w-full
                                h-[320px]
                                object-cover
                                transition-all
                                duration-700
                                group-hover:scale-110
                            "
                                        />

                                        {/* Gradient Overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>

                                        {/* Bottom Content */}
                                        <div className="absolute bottom-0 left-0 right-0 p-5">

                                            {/* Offer Badge */}
                                            <div className="flex items-center justify-between mb-3">

                                                <div className="relative">

                                                    {/* Pulse Animation */}
                                                    <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-30"></span>

                                                    <span
                                                        className={`
            floating-badge relative inline-flex items-center gap-2 rounded-full px-4 py-2 shadow-xl
            transition-all duration-300 group-hover:scale-105
            ${Number(hotel.price_per_night) <= 150
                                                                ? "bg-gradient-to-r from-red-600 to-red-500 text-white"
                                                                : Number(hotel.price_per_night) <= 250
                                                                    ? "bg-gradient-to-r from-green-600 to-green-500 text-white"
                                                                    : "bg-gradient-to-r from-red-600 via-red-500 to-green-600 text-white"
                                                            }
        `}
                                                    >
                                                        <span className="text-lg animate-bounce">
                                                            {Number(hotel.price_per_night) <= 150 ? (
                                                                <BadgePercent className="w-5 h-5 text-white animate-pulse" />
                                                            ) : (
                                                                <Crown className="w-5 h-5 text-white animate-pulse" />
                                                            )}
                                                        </span>

                                                        <div className="leading-tight">
                                                            <p className="text-[9px] uppercase tracking-widest text-white/80">
                                                                Limited Time
                                                            </p>

                                                            <p className="text-xs font-bold">
                                                                {Number(hotel.price_per_night) <= 150
                                                                    ? "Best Price"
                                                                    : Number(hotel.price_per_night) <= 250
                                                                        ? "Save Today"
                                                                        : "Exclusive Deal"}
                                                            </p>
                                                        </div>
                                                    </span>

                                                </div>

                                                <div className="flex items-center gap-1 bg-white/20 backdrop-blur-md px-2.5 py-1 rounded-full">
                                                    <Star
                                                        size={12}
                                                        className="fill-[#FFD54A] text-[#FFD54A]"
                                                    />
                                                    <span className="text-white text-xs font-medium">
                                                        {hotel.rating}
                                                    </span>
                                                </div>

                                            </div>

                                            {/* Hotel Name */}
                                            <h3 className="text-white text-lg font-semibold mb-1 line-clamp-1">
                                                {hotel.name}
                                            </h3>

                                            {/* Location */}
                                            <p className="text-white/80 text-xs flex items-center gap-1">
                                                <MapPin size={12} />
                                                {hotel.location}
                                            </p>

                                        </div>

                                    </div>

                                    {/* Content */}

                                    <div className="p-5 rounded-t-none rounded-b-2xl border border-[#DDD2BA] bg-[#FCFAF5]">

                                        {/* Description */}
                                        <p className="text-gray-500 text-sm leading-6 line-clamp-3 mb-5">
                                            {hotel.short_description ||
                                                "Experience premium accommodation with world-class facilities and exclusive hotel offers."}
                                        </p>

                                        {/* Amenities */}
                                        <div className="flex flex-wrap gap-2 mb-5">
                                            {hotel.amenities?.slice(0, 3).map((item, index) => (
                                                <span
                                                    key={index}
                                                    className="inline-flex items-center gap-1 text-[11px] bg-[#EFE7D5] text-[#0F766E] px-2.5 py-1 rounded-full"
                                                >
                                                    {amenityIcons[item] || null}
                                                    {item}
                                                </span>
                                            ))}
                                        </div>

                                        {/* Footer */}
                                        <div className="border-t border-[#DDD2BA] pt-5 flex items-center justify-between">

                                            <div>

                                                <p className="text-2xl font-semibold text-[#1F2937]">
                                                    AED {Number(hotel.price_per_night).toLocaleString()}
                                                </p>

                                                <p className="text-[11px] uppercase tracking-wider text-gray-500">
                                                    Per Night
                                                </p>

                                            </div>

                                            {/* <a
                                                href={`/hotels/${hotel.slug}`}
                                                className="text-[#0F766E] text-sm font-medium border-b border-[#0F766E] pb-1 transition-all duration-300 hover:text-[#B89442] hover:border-[#B89442]"
                                            >
                                                View Deal →
                                            </a> */}

                                            <span
                                                className="
    text-[#0F766E]
    text-sm
    font-medium
    border-b
    border-[#0F766E]
    pb-1
    transition-all
    duration-300
    hover:text-[#B89442]
    hover:border-[#B89442]
    "
                                            >
                                                View Deal →
                                            </span>

                                        </div>

                                    </div>

                                </a>

                            </div>


                        </div>
                    ))}
                </div>

                {/* Bottom Button */}
                < div className="mt-16 text-center" >
                    <button
                        className="
            group
            inline-flex
            items-center
            gap-3
            rounded-2xl
            bg-[#D9BB74]
            px-8
            py-3
            text-sm
            font-semibold
            text-[#1B1B1B]
            shadow-lg
            transition-all
            duration-300
            hover:bg-[#0F766E]
            hover:text-white
            hover:scale-105
            hover:shadow-xl
        "
                    >
                        <Hotel size={18} />

                        <span>
                            View All Hotels
                        </span>

                        <ArrowRight
                            size={18}
                            className="
                transition-transform
                duration-300
                group-hover:translate-x-2
            "
                        />
                    </button>
                </div>
            </div>
        </section >
    );
}